'use strict';
var food = {
    Drink: {
        Wine: {},
        Schnaps: {}
    },
    Fruit: {
        Red: {
            Cherry: {},
            Strawberry: {}
        },
        Yellow: {
            Banana: {},
            Pineapple: {}
        }
    }
};
var tree = document.querySelector('#tree');
/**
 *
 * @param {HTMLElement} element
 * @param {Object} data
 * @returns
 */ function createTree(element, data) {
    if (Object.keys(data).length === 0) return;
    var elementUl = document.createElement('ul');
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(data)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var elementLi = document.createElement('li');
            elementLi.textContent = key;
            elementUl.append(elementLi);
            createTree(elementLi, data[key]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    element.append(elementUl);
}
createTree(tree, food);

//# sourceMappingURL=js_tree-from-object-DOM.acd185a4.js.map
